$(document).ready(function() {
    $('[data-slicker]').slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 10000,
        appendArrows: false,
        dots: true,
        pauseOnHover: true,
        mobileFirst: true,
        width: 'auto'
    });
});
